import React, { useState, useEffect } from "react";
import {
  FormControl,
  InputLabel,
  InputAdornment,
  IconButton,
  OutlinedInput,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IField } from "../../app/types";
import { StyleUtils } from "../../app/utils/styleUtils";
import { setFieldValue } from "../MainContent/MainContentUtils";
import { useAppSelector } from "../../app/hooks";
import { showWarning } from "../../app/utils/validationUtils";

/* Functional component properties */
interface Props {
  classes: any;
  item: IField;
  isGridElem: boolean;
  setWidth: string;
  clear: string;
  setClear: (clr: string) => void;
}

/* React Functional component */
export const PasswordField: React.FC<Props> = ({
  /* Function arguments (Props) */
  classes,
  item,
  isGridElem,
  setWidth,
  clear,
  setClear,
}): JSX.Element => {
  /* get state */
  const state = useAppSelector((state) => state);

  const [val, setVal] = useState({
    password: "",
    showPassword: false,
  });

  useEffect(() => {
    if (item.value !== val.password) {
      setVal({ ...val, password: item.value });
    }
  }, [state.mainContent.fieldList]);

  useEffect(() => {
    setFieldValue(item.name, val.password); // Set value in redux store mainContent.fieldList
  }, [val]);

  useEffect(() => {
    if (
      clear === "true" &&
      item.editable &&
      item.editable === "true" &&
      val.password !== ""
    ) {
      setClear("false");
      setVal({ ...val, password: "" });
      // setFieldValue(item.name, ""); // Set value in redux store mainContent.fieldListsetFieldValue(props.item, "", props.idx);
    } else if (clear === "true") {
      setClear("false");
    }
  });

  function handleMouseLeave(
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) {
    if (item.value !== val.password)
      setFieldValue(item.name, (event.target as HTMLInputElement).value); // Set value in redux store mainContent.fieldList
  }

  function handleChange(
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) {
    window.myGlobalVar.pendingChanges.status = true; // Set pending changes
    if (window.myGlobalVar.pendingChanges.items.indexOf(item.name) === -1)
      window.myGlobalVar.pendingChanges.items.push(item.name);
    window.myGlobalVar.pendingChanges.showWarning = false;
    setVal({ ...val, password: event.target.value }); // Set local state value in useState
  }

  function handleClickShowPassword() {
    setVal({ ...val, showPassword: !val.showPassword });
  }

  return (
    <FormControl
      variant="outlined"
      // {...(showWarning(item.name) ? { color: "warning" } : {})}
      // {...(showWarning(item.name)
      //   ? { focussed: "true" }
      //   : { focussed: "false" })} //Modified Fields
    >
      <InputLabel htmlFor={item.name}>Password</InputLabel>
      <OutlinedInput
        // {...(showWarning(item.name) ? { color: "warning" } : {})}
        // {...(showWarning(item.name)
        //   ? { focussed: "true" }
        //   : { focussed: "false" })} //Modified Fields
        {...(item.editable && item.editable === "true"
          ? {}
          : { disabled: true })} //Disabled Fields
        className={
          item.visible && item.visible === "false" ? classes.hiddenField : "" //Hidden Fields
        }
        type={val.showPassword ? "text" : "password"}
        label={item.name}
        name={item.name}
        id={item.name}
        value={val.password}
        onChange={(e) => handleChange(e)}
        onMouseLeave={(e) => handleMouseLeave(e)}
        inputProps={{
          maxLength: item.length ? item.length : "", // Max input length
        }}
        style={
          setWidth === "true"
            ? {
                width: `${(() => StyleUtils.getWidth(item))()}px`, // Calculating width of the field
              }
            : {}
        }
        error={
          (state.mainContent.messageList.length > 0 &&
            state.mainContent.messageList.find(
              (msg) =>
                msg.fields !== undefined && msg.fields?.indexOf(item.name) >= 0
            ) !== undefined) ||
          showWarning(item.name)
        }
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={() => handleClickShowPassword()}
              //   onMouseDown={(e) => handleMouseDownPassword(e)}
              edge="end"
            >
              {val.showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        }
      />
      {/* {state.mainContent.messageList.length > 0 &&
      state.mainContent.messageList.find(
        (msg) => msg.fields !== undefined && msg.fields?.indexOf(item.name) >= 0
      ) !== undefined ? (
        <FormHelperText>Error</FormHelperText>
      ) : (
        ""
      )} */}
    </FormControl>
  );
};
